import AuthorizationService from '../services/authorization.service'

export const authorizationModule = {
  namespaced: true,

  state: {
    authorizations: [],
    authorization: undefined,
    authorizationDetail: null,
    criterias: null,
    invalidData: null
  },

  actions: {
    async search ({ commit }, criterias) {
      return AuthorizationService.search(criterias).then(
        response => {
          const authorizations = response.data
          commit('searchSuccess', authorizations)
          return Promise.resolve(authorizations)
        },
        error => {
          commit('searchFailure')
          return Promise.reject(error.response.data)
        }
      )
    },

    async get ({ commit }, id) {
      return AuthorizationService.get(id).then(
        response => {
          const authorization = response.data
          commit('getSuccess', authorization)
          return Promise.resolve(authorization)
        },
        error => {
          commit('getFailure')
          return Promise.reject(error.response.data)
        }
      )
    },

    async reset ({ commit }) {
      commit('listReset')
    },

    async setAuthorizationDetail({ commit }, authorization) {
      commit('authorizationSuccess', authorization)
    },

    async setCriterias ({ commit }, criterias) {
      commit('setCriterias', criterias)
    },

    async resetCriterias ({ commit }) {
      commit('resetCriterias')
    },

    async invalidData ({ commit }, error) {
      commit('invalidData', error)
    },

    async resetInvalidData ({ commit }) {
      commit('invalidData', null)
    }
  },

  mutations: {
    getSuccess (state, authorization) {
      state.authorization = authorization
    },
    getFailure (state) {
      state.authorization = undefined
    },
    listReset (state) {
      state.authorizations = []
    },
    searchSuccess (state, authorizations) {
      state.authorizations = authorizations
    },
    searchFailure (state) {
      state.authorizations = []
    },
    authorizationSuccess (state, authorization) {
      state.authorizationDetail = authorization
    },
    setCriterias (state, criterias) {
      state.criterias = criterias
    },
    resetCriterias (state) {
      state.criterias = null
    },
    invalidData (state, error) {
      state.invalidData = error
    }
  }
}
